export default {
  appSources: {
    bluebird: "bluebird",
    commission: "commission",
    admin: "admin",
    analytics: "analytics",
    leadership: "leadership",
    daylight: "daylight",
    
  },
  expenseTypes: {
    0: "Manual",
    1: "Auto Generated",
    2: "Email",
  },
  mileageTypes: {
    0: "Call Plan",
    1: "Location Points",
    2: "Manual",
  },

  bypassAdmins: [
    "hvadugula@skyralytics.com",
    "rthota@skyralytics.com",
    "pnaredla@skyralytics.com",
    "manoj@skyralytics.com",
  ],

  callBackAnalysisServiceLines: 'HOME HEALTH',
  callBackAnalysisPageDataSize: 100,
  serviceLines: {
    'HOME HEALTH': 'home health',
    'HOSPICE': 'hospice',
  },
  validation: {
    dataStaleness: 30
  },

  /**
   * Accounts allowed into the Charlie feature (the Administrator Daily Brief).
   * Charlie is behind this flag while it ships on mock data — the nav entry and
   * its route are both gated on it, so an account that isn't listed here cannot
   * reach the screen even by typing the URL.
   *
   * An entry matches the signed-in user's email either whole
   * ("someone@example.com") or by its local part ("vna.bill.demo" enables
   * vna.bill.demo@<any domain>). Matching is case-insensitive.
   * See `src/config/featureFlags.ts`.
   */
  charlieAccounts: [
    //"vna.bill.demo",
    "bill.demo@skyralytics.com"
  ],
};
